import { type Registry as Services } from '@ember/service';

import { kycQueries, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

import { ErrorInfo } from 'register-partners-js/utils/error-info';

export async function fetchKyc({
  sentry,
  queryClientManager,
  isSingleKycEnabled,
  market,
}: {
  sentry: Services['sentry'];
  queryClientManager: Services['queryClientManager'];
  isSingleKycEnabled: boolean;
  market: string;
}): Promise<KycResponse | null> {
  try {
    if (!isSingleKycEnabled) {
      return null;
    }

    return await queryClientManager.queryClient.ensureQueryData(kycQueries.item({ market }));
  } catch (error) {
    let errorInfo = ErrorInfo.for(error);

    if (errorInfo.shouldSendToSentry) {
      sentry.captureException(error);
    }

    return null;
  }
}
